/**
 * DialectFlag — real-flag glyphs for the dialect selector (Spain / LatAm / Both).
 *
 * The shared @/ui FlagIcon only ships ES + UK. iOS shows 🇪🇸 / 🇲🇽 / 🌎 for the
 * three dialect options, but the project rule forbids emoji flags. So Spain reuses
 * the shared FlagIcon (ES); Mexico is a small inline SVG of the Mexican flag (a
 * real flag, not emoji/text); "Both" uses a globe glyph. Kept local to this track.
 */
import { FC } from "react";
import { Globe } from "lucide-react";
import { FlagIcon, colors, FlagSize } from "@/ui";

// Match the shared FlagIcon dimensions so dialect flags line up with ES/UK.
function flagWidth(size: FlagSize) {
  return size === "small" ? 21 : size === "large" ? 32 : 28;
}

const MexicoFlag: FC<{ size: FlagSize }> = ({ size }) => {
  const W = flagWidth(size);
  const H = Math.round((W * 2) / 3);
  return (
    <svg viewBox="0 0 21 14" width={W} height={H} style={{ borderRadius: 2 }}>
      <rect x="0" y="0" width="7" height="14" fill="#006847" />
      <rect x="7" y="0" width="7" height="14" fill="#ffffff" />
      <rect x="14" y="0" width="7" height="14" fill="#CE1126" />
      <circle cx="10.5" cy="7" r="1.6" fill="#9b6a37" />
    </svg>
  );
};

export const DialectFlag: FC<{ kind: "spain" | "latam" | "both"; size?: FlagSize }> = ({
  kind,
  size = "large",
}) => {
  if (kind === "spain") return <FlagIcon countryCode="ES" size={size} />;
  if (kind === "latam") return <MexicoFlag size={size} />;
  return <Globe size={Math.round((flagWidth(size) * 2) / 3)} color={colors.blue} />;
};

export default DialectFlag;
